import React from "react";

// A list-row image, or a grey box of the same size so rows stay aligned.
const Thumbnail = (props) => props.src
    ? <img src={props.src} alt={props.alt} className="w-10 h-10 object-cover rounded"/>
    : <div title="No image" className="w-10 h-10 rounded bg-gray-100"/>;

export default Thumbnail;
